import React, { Children, Suspense, cloneElement, lazy } from "react";

// import { AddToHomeScreenButton } from "../addToHomeScreenButton/AddToHomeScreenButton";
import { Header } from "./Header";
import { Footer } from "./Footer";

import "./layout.css";

import "../../styles/bootstrap.css";
import "../../styles/style.css";
import "../../styles/responsive.css";
import "../../styles/slick-theme.css";
import "../../styles/slick.css";
import "../../styles/scrollbar.css";

const CookieConsent = lazy(() => import("../Cookies"));
export const Layout = ({ children, location, lang }, props) => {
  const { pathname } = location;

  // in case there doesnt exist a blog with translation, take me to content index
  // if blog then /blog/ or /en/blog
  const isEnglishContent = lang === "en";
  let pathSegments = location.pathname.split("/");

  let indexContent = isEnglishContent
    ? `/${pathSegments[2]}/`
    : `/en/${pathSegments[1]}/`;

  const isContentTypePage = children?.props?.pageContext?.id?.includes("Page_");
  if (isContentTypePage) {
    indexContent = isEnglishContent ? "/en/" : "/";
  }
  //check if layout children has langSwitchURL
  const langSwitchURL = children?.props?.pageContext?.langSwitchURL;

  const isHome = pathname === "/" || pathname === "/en/";
  const allowedUrls = ["/enviar-dinero", "/en/send-money"];
  const isAllowedUrl = !!allowedUrls.find((url) => pathname.includes(url));

  const isBannerAllowed = isHome || isAllowedUrl;

  //===== iframe ===========
  const isIframePage =
    pathname === "/calculadora/" || pathname === "/calculadora-recargas/";

  if (isIframePage) {
    return (
      <main>
        <Suspense fallback={null}>
          {Children.map(children, (child, index) =>
            cloneElement(child, { key: index, lang }),
          )}
        </Suspense>
      </main>
    );
  }

  return (
    <>
      {/* <AddToHomeScreenButton /> */}
      <Header
        location={location}
        isHome={isHome}
        lang={lang}
        bannerDisplay={isBannerAllowed}
        langSwitchURL={langSwitchURL}
      />

      {Children.map(children, (child, index) =>
        cloneElement(child, { key: index, lang }),
      )}

      <Suspense fallback={null}>
        <CookieConsent lang={lang} location={location} />
      </Suspense>

      <Footer lang={lang} location={location} langSwitchURL={langSwitchURL} />
    </>
  );
};
